import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';

const SlideShow = ({images}) => {

  return (
    <div className="flex flex-col border border-bg-brand-lightgray bg-brand-lightgray rounded-lg">
      <Carousel showArrows={true} showThumbs={false} showStatus={false} scrollable={true}
                renderIndicator={(onClickHandler, isSelected, index, label) => {
                  return (
                    <div
                      className="inline-flex justify-center"
                      onClick={onClickHandler}
                      onKeyDown={onClickHandler}
                      key={index}
                      role="button"
                      tabIndex={0}
                      aria-label={`${label} ${index + 1}`}
                    >
                      <div
                        className={`rounded-full z-20 cursor-pointer p-1.5 mr-2 border-2 border-gray-800 ${isSelected ? 'bg-gray-800' : ''}`}/>
                    </div>
                  );
                }}
      >
        {images?.map((image) => (
          <img
            src={image.image_url.startsWith('https://') ? image.image_url : image.image_url.replace(/^http:\/\//i, 'https://')}
            className="px-5 pt-5 pb-8 object-contain inset-0 transform ease-in h-96 w-74 md:h-80 md:w-58 xl:h-96 xl:w-74"
            alt="user"
          />
        ))}
      </Carousel>
    </div>
  )
}
export default SlideShow;
